import { render, staticRenderFns } from "./DeleteUserProfile.vue?vue&type=template&id=47965e8b"
import script from "./DeleteUserProfile.vue?vue&type=script&lang=ts"
export * from "./DeleteUserProfile.vue?vue&type=script&lang=ts"
import style0 from "./DeleteUserProfile.vue?vue&type=style&index=0&id=47965e8b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports